import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, Renderer2 } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ManualAwardsService } from '../../../services/manual-awards.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { PointStorePermissionService } from 'src/app/gamification/marketplace/admin/services/point-store-permission.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { AliasPageName } from 'src/app/gamification/cv-marketplace-admin/models/gamification-pages.model';

interface ViewChange {
    view: any;
    item: any;
    old: any;
}

@Component({
    selector: 'cv-awards-card-menu',
    templateUrl: './awards-card-menu.component.html',
    styleUrls: ['./awards-card-menu.component.scss']
})
export class AwardsCardMenuComponent implements OnInit {
    @Input() item: any;   //award card item
    @Input() visible: boolean; //send item.showOptions
    @Output() onChangeView = new EventEmitter<ViewChange>(); //this function should update the view and set the item to be sent to the other view (edit or copy)
    @Input() removeAwardFromFrontend: (item: any) => void; //function to update the lading cards
    @Input() resetToOriginal: () => void;
    @Input() isCopyChange: (status: boolean, newItem: any) => void;
    @Input() isCopy: boolean;
    @Input() _old: any;
    @Output() updateOldValue: EventEmitter<any> = new EventEmitter();
    @Input() isCxOne: boolean;
    view: any;

    Views = {
        Main: 0,
        AddEdit: 1
    };

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private manualAwardsService: ManualAwardsService,
        private dialogService: CvCustomDialogService,
        private el: ElementRef,
        private renderer: Renderer2,
        private cdr: ChangeDetectorRef,
        private zone: NgZone,
        private pointStorePermissionService: PointStorePermissionService,
        private cvConfigurationService: CvConfigurationService
    ) { }

    ngOnInit(): void {
        this.item = this.item || {};
        this.initializeClickOutsideListener();
        this.cvLocalizationService.GetSection("Manual_Awards_Validation");
    }

    private initializeClickOutsideListener(): void {
        this.renderer.listen('document', 'click', (event) => {
            if (!this.el.nativeElement.contains(event.target) && this.visible) {
                this.zone.run(() => {
                    this.visible = false;
                    this.item.showOptions = false;
                    this.cdr.detectChanges();
                });
            }
        });
    }


    Edit(existing) {
        this.isCopyChange(false, null);

        if (!this.isCopy && JSON.stringify(this._old) !== JSON.stringify(existing)) {
            this._old = { ...existing };
        }

        if (!this.isCopy && JSON.stringify(this.item) !== JSON.stringify(existing)) {
            this.item = { ...existing };
        }

        this.item.AssignedGroups = [];
        this.item.AssignedGroups = this.item.AssignedEmpGroups;
        this.updateOldValue.emit(this._old);
    }

    Copy(existing) {
        this.isCopyChange(true, null);
        if (this._old !== existing) {
            this._old = { ...existing };
        }

        if (this.item !== existing) {
            this.item = { ...existing };
        }

        // Setup assign tool values:
        this.item.AssignedGroups = [];
        this.item.AssignedGroups = this.item.AssignedEmpGroups;
        this.item.RuleID = 0;
        
        this.updateOldValue.emit(this._old);
    }

    emitViewChange(view: any, item: any, old: any) {
        const viewChange: ViewChange = { view, item, old };
        this.onChangeView.emit(viewChange);
    }

    async edit() {
        const hasEditPermission: boolean = await this.pointStorePermissionService.validatePermission({
            name: this.pointStorePermissionService.getEditPermissionName(),
            pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.AwardsTab),
            newCXoneModalVersion: true
        }, !this.cvConfigurationService.isCxOne);
        if (!hasEditPermission) {
            return;
        }

        this.resetToOriginal();
        this.Edit(this.item);
        const itemClone = _.cloneDeep(this.item);
        this.emitViewChange(this.Views.AddEdit, itemClone, this._old);
    };

    async copy() {
        const hasCreatePermission: boolean = await this.pointStorePermissionService.validatePermission({
            name: this.pointStorePermissionService.getCreatePermissionName(),
            pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.AwardsTab),
            newCXoneModalVersion: true
        }, !this.cvConfigurationService.isCxOne);
        if (!hasCreatePermission) {
            return;
        }

        // this.resetToOriginal();
        this.Copy(this.item);
        this.emitViewChange(this.Views.AddEdit, this.item, this._old);
    }

    deactivateManualAward(item: any): void {
        this.manualAwardsService.deactivateManualAward(item)
            .then((result: any) => {
                if (result) {
                    this.removeAwardFromFrontend(item);
                }
            })
            .catch((error: any) => {
                console.error('Error deactivating manual award:', error);
            });
    }


    async delete(e) {
        e.stopPropagation();
        const hasEditPermission: boolean = await this.pointStorePermissionService.validatePermission({
            name: this.pointStorePermissionService.getEditPermissionName(),
            pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.AwardsTab),
            newCXoneModalVersion: true
        }, !this.cvConfigurationService.isCxOne);
        if (!hasEditPermission) {
            return;
        }
        
        const modalOptions: NgbModalOptions = {
            keyboard: false,
            backdrop: 'static',
            centered: true,
            windowClass: this.isCxOne ? 'cxone-modal-awards' : '',
        };
        const modalTitle = this.cvLocalizationService.getCachedText("Manual_Awards_Validation", this.isCxOne ? "Delete_Award" : "Confirm_Action", this.isCxOne ? "Delete award?" : "Confirm Action");
        const prompt = "<p class='modal-body-text pb-2'>" + this.cvLocalizationService.getCachedText("Manual_Awards_Validation", "Confirm_Delete_Message", "Are you sure you want to delete this award? This action cannot be undone.") + "</p>";
        const okLabel = this.cvLocalizationService.getCachedText("Common", this.isCxOne ? "Delete" : "Ok", this.isCxOne ? "Delete" : "Ok");
        const cancelLabel = this.cvLocalizationService.getCachedText("Common", "Cancel_Button", "Cancel");
        if (this.isCxOne) {
            this.dialogService.showDialog(modalTitle, prompt, 11, cancelLabel, okLabel, true, () => { this.deactivateManualAward(this.item); }, () => { }, '', true, modalOptions);
        } else {
            this.dialogService.showDialog(modalTitle, prompt, 4, cancelLabel, okLabel, true, () => { this.deactivateManualAward(this.item); }, () => { }, 'upload-dialog', true, modalOptions);
        }
    }
    
    hasPermission(permission: string): boolean {
        return this.pointStorePermissionService.checkPermission(permission,
            this.pointStorePermissionService.pageNameFilter(AliasPageName.AwardsTab)
        );
    }
}
